import React from 'react';
import { cx } from '@linaria/atomic';
import { Label } from '../atoms/label.component';
import { groupLabel } from './group-label.styles';

type Props = {
  className?: string;
  id: string;
  children: React.ReactNode;
};

export const GroupLabel: React.FC<React.PropsWithChildren<Props>> = ({ children, className, ...rest }) => {
  return (
    <Label className={cx(groupLabel, className)} {...rest}>
      {children}
    </Label>
  );
};
